module.exports = __webpack_public_path__ + "static/media/PendingIcon.afc33a81.svg";